import { includes } from 'lodash-es';

import { getConfig } from '../config';

export const getFeatureEnabledForCountry = (
  countryCodeParam: string | undefined | null
) => {
  const countryCode = countryCodeParam?.toUpperCase();
  const { FEATURE_ENABLED_FOR_COUNTRIES } = getConfig();

  return {
    isPaymentEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.payment,
      countryCode
    ),
    isPaymentQREnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.paymentQR,
      countryCode
    ),
    isWhatsappEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.whatsapp,
      countryCode
    ),
    isCandidateWhatsappEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.candidateWhatsapp,
      countryCode
    ),
    isChatEnabled: includes(FEATURE_ENABLED_FOR_COUNTRIES.chat, countryCode),
    isCSVExportEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.csvExport,
      countryCode
    ),
    isApplicationHistoryEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.applicationHistory,
      countryCode
    ),
    isProfileLimitAccessEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.profileLimitAccess,
      countryCode
    ),
    cvFinderEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.cvFinder,
      countryCode
    ),
    isFeaturesPageEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.featuresPage,
      countryCode
    ),
    isRecommendedTalentEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.recommendedTalent,
      countryCode
    ),
    isCreditSystemEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.creditSystem,
      countryCode
    ),
    isSelfServePremiumPlanEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.selfServePremiumPlan,
      countryCode
    ),
    isJobSuccessPageEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.jobSuccessPage,
      countryCode
    ),
    isVIPMembershipEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.vipMembership,
      countryCode
    ),
    isWorkAddressEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.workAddress,
      countryCode
    ),
    isApplicationRecordEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.applicationRecord,
      countryCode
    ),
    isEmployerAppDownloadCTAEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.employerAppDownloadCTA,
      countryCode
    ),
    isAutoRenewalEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.autoRenewal,
      countryCode
    ),
    isAIGenJobDescriptionEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.aiGenJobDescription,
      countryCode
    ),
    isUseMobileAppPromptEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.useMobileAppPrompt,
      countryCode
    ),
    isSalaryVisibleForJob: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.salaryVisibilityControlForJob,
      countryCode
    ),
    isTierVerificationEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.tierVerification,
      countryCode
    ),
    isJobMetricsEnabledForCountry: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.jobMetrics,
      countryCode
    ),
    isHierarchicalLocationEnabled: includes(
      FEATURE_ENABLED_FOR_COUNTRIES.hierarchicalLocation,
      countryCode
    ),
  };
};
